module.exports = __webpack_public_path__ + "static/media/GC King Bond GP Inc. - Consent Order dated November 20- 2024.b5e33481.pdf";